import { CTAPIConfiguration } from './utils/configuration';
import { RequestHelper } from './utils/request';
import { CustomerRestInterface } from './interfaces/_customer.rest';
import { Customer } from '../models/interfaces/_customer.model';
import { CustomerObject } from '../models/customer.model';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class CustomerRest implements CustomerRestInterface {

    private configuration: CTAPIConfiguration;
    private requestHelper: RequestHelper;

    constructor(configuration: CTAPIConfiguration) {
        this.configuration = configuration;
        this.requestHelper = new RequestHelper(configuration);
    }

    /**
     * Request for customers list.
     */
    getCustomers(nDivID: number, sEnvCode, sCustFull): Observable<Customer[]> {
        return this.requestHelper.request({ data: { nDivID, sEnvCode, sCustFull } }, this.configuration.customer.get,
            this.configuration.httpClient).pipe(
                map((response) => {
                    const rawCustomers: any[] = response.result.customers;
                    const customer: Customer[] = rawCustomers.map((c) => {
                        return new CustomerObject(
                            c.sCustFull,
                            null,
                            c.nCustID,
                            c.bPcCreditStop,
                            c.custName,
                            c.sVatNumber,
                            c.sDefaultCurrency
                        );
                    });
                    return customer;
                })
            );
    }

    /**
     * Request for customer by code.
     */
    getCustomerByCode(code: string, nDivID, sEnvCode): Observable<Customer> {
        return this.requestHelper.request({ data: { sCustCode: code, nDivID, sEnvCode } }, this.configuration.customer.getByCode,
            this.configuration.httpClient).pipe(
                map((response) => {
                    const rawCustomers: any = response.result.customer;
                    return rawCustomers 
                      ? new CustomerObject(rawCustomers.
                      sCustFull,
                      rawCustomers.
                      sCustCode,
                      rawCustomers.
                      nCustID,
                      rawCustomers.
                      bPcCreditStop,
                      rawCustomers.
                      custName,
                      rawCustomers.
                      sVatNumber,
                      rawCustomers.
                      sDefaultCurrency) : null;
                })
            );
    }

    getSalesOrganization(nDivId, sEnvCode) {
        return this.requestHelper.
          request({ data:
          { nDivID:
          nDivId,
          sEnvCode } }, this.
          configuration.
          salesOrderOrganization.
          list,
          this.
          configuration.
          httpClient).
          pipe(map((response) => {
            return !!response && !!response.result ? response.result.organizations : [];
        }));
    }

}
